import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BasemodelService } from 'src/app/basemodel.service';

@Injectable({
  providedIn: 'root'
})
export class StudentMigrationService {

    // token="eyJhbGciOiJIUzI1NiJ9.eyJ0b2tlblJlZnJlc2hLZXkiOiJKdWVmWjlvd2VTZzFmbDhVWWZrTzVsNWhobHpZejZXcFNPNHBleFRtVHE0JTNEIiwiY2FtcHVzSWQiOjE3OSwicGF5cm9sbElkIjoiSFlEMTAzMTM1IiwidXNlck5hbWUiOiJDSCBTQVRZQU5BUkFZQU5BIiwiZXhwIjoxNzQ1MzAyNzE2LCJ1c2VySWQiOiJIWUQxMDMxMzUiLCJpYXQiOjE3NDUyMTYzMTYsInVuaXF1ZUlkIjoyODQ4NiwianRpIjoiMjgxOTY4NWItMzZkZS00YWU0LWI0YzAtNzhkMzYwMDEwMTE4In0.-AVGLyd6k_yxGYeua6vImJZEG5OdnYy1VXABlx6VCgY"
    constructor(private http:HttpClient,public baseURL :BasemodelService) { }
    Search(payload:any){
     
      
      return this.http.post( this.baseURL.getCommonUrl()+"/employee/api/jwtV2/college/studentSearch",payload,)
    }
    Resentsearch(){
    
      // return this.http.get( "https://testmisreports.scaits.net/employee/api/jwtV2/common/search/getsearchCache?searchType=STUDENT",{headers})
  
    }
    savestudentdata(admission: any, name: any, student: any, favourite: any, businessType:any, parentName: any): Observable<any> {
      const params = new HttpParams()
        .set('searchSelected', admission)
        .set('searchKey', name)
        .set('searchType', student)
        .set('favourite', favourite) 
        .set('businessType',businessType)
        .set('parentName', parentName);
    
      return this.http.post( "https://testmisreports.scaits.net/employee/api/jwtV2/common/search/saveSearchCache?", {}, { params: params }); 
    }
    orgnation(){
      return this.http.get(this.baseURL.getcounsellingURL()+"/auth/jwt/student/organizations",)
    }
    afferstudent(admNo:any,orgId:any){
      const params = new HttpParams()
      .set('admNo', admNo)
      .set('orgId', orgId)
    
      return this.http.post(this.baseURL.getcounsellingURL()+'/student/v1/after2025OrgChange?',{},{ params: params })

    }
    beforestudent(admNo:any,orgId:any){
      const params = new HttpParams()
      .set('admNo', admNo)
      .set('orgId', orgId)
    
      return this.http.post(this.baseURL.getcounsellingURL()+'/student/v1/before2025OrgChange?',{},{ params: params })
    }
}
